import { configureStore } from "@reduxjs/toolkit";
import { routerMiddleware } from "./modules/router/routerAdapter";
import reducer from "./modules";
import { enableReducerHotReload } from "./store.devtools";
import { analyticsMiddleware } from "./middleware/analytics";
import { facetDebounceMiddleware } from "./middleware/facetDebounce";

export default (history, state) => {
  const store = configureStore({
    reducer: reducer(history),
    preloadedState: state,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({ serializableCheck: false }).concat(
        routerMiddleware(history),
        analyticsMiddleware,
        facetDebounceMiddleware
      )
  });

  enableReducerHotReload(store, history);

  return store;
};
